import Cookies from "js-cookie";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HorizontalMenu from "../components/horizontalMenu";
import ChallengeCard from "../components/ChallengeCard";
import { convertDateFormat } from "../utils/dateFormat";
import { Accordion } from "react-bootstrap";
import "./Home.css";
import moment from "moment";
import axiosInstance from "../utils/axiosInstance";
import { FcInvite } from "react-icons/fc";
import NoChallengesAvailable from "../components/NoChallengesAvailable";
import Dashboard from '../components/Dashboard';
import TemplatePage from "./TemplatePage";

function Home() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [startDay, setStartDay] = useState("");
  const [challengesArray, setChallengesArray] = useState([]);
  const [invitationsArr, setInvitationsArr] = useState([]);
  const [templatesArray, setTemplatesArray] = useState([]);
  moment().format("MMMM D, YYYY");

  const navigate = useNavigate();

  const authToken = Cookies.get("authToken");

  useEffect(() => {
    const headers = {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    };

    axios
      .get(`${process.env.REACT_APP_API_URL}/challenges/invitation`, { headers })
      .then((response) => {
        setInvitationsArr(response.data);
      })
      .catch((error) => {});

    axios
      .get(`${process.env.REACT_APP_API_URL}/challenges/public`)
      .then((response) => {
        setChallengesArray(response.data);
        setTitle(response?.data?.[0]?.title || "");
        setDescription(response.data[0].description || "");
        setStartDay(convertDateFormat(response.data[0].start_date));
      })
      .catch((error) => {});

    axiosInstance
      .get("/templates")
      .then((response) => setTemplatesArray(response.data))
      .catch((error) => {});
  }, []);



  const sendInvitationResponse = (response, challenge_oid) => {
    const data = response === "spectator"
      ? { response, challenge_oid }
      : {
          acceptance_status: response === "participant",
          challenge_oid,
        };

    axiosInstance.put("/challenges/invitation", data).then(() => {
      setInvitationsArr((currentInvitations) =>
        currentInvitations.filter(
          (item) => item.challenge_oid !== challenge_oid
        )
      );
    });
  };

  return (
    <div>
      <HorizontalMenu />

      <h4 style={{ margin: "10px" }}>Invitations</h4>

      {invitationsArr.length > 0 ? (
        ""
      ) : (
        <NoChallengesAvailable text="No new invitations! Consider creating your own challenge or joining a community challenge! " />
      )}
      {invitationsArr.map((invitationObj) => {
        return (
          <div style={{ width: "100%" }}>
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <FcInvite /> &nbsp; Invitation: {invitationObj.title}
                </Accordion.Header>
                <Accordion.Body>
                  <span style={{ maxWidth: "275px", display: "inline-block" }}>
                    <b>{invitationObj.sender}</b> invited you to join them in a
                    challenge:{" "}
                    <button
                      className="accept-button"
                      onClick={() =>
                        sendInvitationResponse(
                          "participant",
                          invitationObj.challenge_oid
                        )
                      }
                    >
                      Join
                    </button>
                    <button
                      className="accept-button"
                      onClick={() =>
                        sendInvitationResponse(
                          "spectator",
                          invitationObj.challenge_oid
                        )
                      }
                    >
                      Watch
                    </button>
                    <button
                      className="delete-button"
                      onClick={() =>
                        sendInvitationResponse(
                          "declined",
                          invitationObj.challenge_oid
                        )
                      }
                    >
                      Delete
                    </button>
                  </span>

                  <div className="invite-details-card">
                    <h4 className="invite-title">{invitationObj.title}</h4>
                    <p>
                      <span id="details">Description:</span>{" "}
                      {invitationObj.description}
                    </p>
                    <p>
                      <span id="details">Start Date:</span>{" "}
                      {moment(invitationObj.start_date).format("MMMM D, YYYY")}
                    </p>
                    <p>
                      <span id="details">Participants:</span>{" "}
                      {invitationObj.participant_num}{" "}
                    </p>
                    {invitationObj.rules}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        );
      })}

      <hr></hr>

      <h4 style={{ margin: "10px" }}>Dashboard</h4>
      <Dashboard></Dashboard>

      <hr></hr>

      <h4 style={{ margin: "10px" }}>Challenge Templates</h4>

      <div style={{ margin: "10px" }}>Use our pre-built templates to create a new challenge. Feel free to adjust the details to make it your own! You can also save the template for later usage.</div>
      <TemplatePage />
    
      <hr></hr>
      <h4 style={{ margin: "10px" }}>Public Community Challenges</h4>
      {challengesArray.length > 0 ? (
        challengesArray.map((value) => (
          <ChallengeCard
            key={value._id}
            title={value.title}
            description={value.description}
            startDay={convertDateFormat(value.start_date)}
            allData={value}
          />
        ))
      ) : (
        <NoChallengesAvailable text="No public challenges currently available." />
      )}
    </div>
    
  );
}

export default Home;
